import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { BootstrapVue } from 'bootstrap-vue';

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faMicrophone, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'

/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


/* add icons to the library */
library.add(faMicrophone, faExclamationCircle)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)

import App from './pages/App.vue'
import {store} from './store';
import router from "./router";

console.log(`Version: ${process.env.VUE_APP_VERSION || '0'}`),

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')

